import XIcon from "@mui/icons-material/X";
import Link from "@mui/material/Link";
import { Colors } from "../../../../utilities/styles";

interface Props {
  url: string;
  text?: string;
}

export default function XShareButton({url, text}: Props) {
  const shareUrl = `https://x.com/intent/post?url=${encodeURIComponent(
    url
  )}${text ? `&text=${encodeURIComponent(text)}` : ""}`;

  return (
    <Link
      href={shareUrl}
      sx={{ "&:hover": { color: Colors.XBlack }, color: "grey" }}
      target="_blank"
      rel="noopener"
      aria-label="X Share Button"
    >
      <XIcon />
    </Link>
  );
}
